<template>
  <div
    class="relative rounded-2xl overflow-hidden p-[16px] text-[16px]"
    :class="[cardStyle, cardHtml ? 'pt-0' : 'pt-8']"
  >
    <!-- Fully custom override: render cardHtml wholesale, skip structured layout -->
    <html-to-vue v-if="cardHtml" :html="cardHtml" />

    <template v-else>
      <div class="font-aktiv-grotesk-trial mb-3">
        {{ title }}
      </div>
      <div v-if="date" class="flex mb-1 justify-start items-start">
        <img
          src="../../../public/assets/icons/event-date-icon-orange.svg"
          alt="icon"
          class="mt-[2px]"
        />
        <div>
          <p class="ml-2">
            {{ date }}
          </p>
        </div>
      </div>
      <div v-if="expTime" class="flex mb-1 justify-start items-start">
        <img
          src="../../../public/assets/icons/event-duration-icon-orange.svg"
          alt="icon"
          class="mt-[2px]"
        />
        <div>
          <p class="ml-2">
            {{ expTime }}
          </p>
        </div>
      </div>
      <div v-if="location && location.length > 0" class="flex mb-1 justify-start items-start">
        <img
          src="../../../public/assets/icons/event-location-icon-orange.svg"
          alt="icon"
          class="mt-1 ml-1"
        />
        <div class="flex flex-col">
          <p v-for="locate in location" :key="locate" class="ml-2">
            {{ locate }}
          </p>
        </div>
      </div>

      <!-- Rich note (bold/underline/emoji/links) -->
      <div v-if="note" class="text-[14px] leading-[20px] text-[#666666] mt-1">
        <html-to-vue :html="note" />
      </div>

      <CardLabel v-if="conferenceType === 'Global'" color="green">Confirmed</CardLabel>

      <!-- Data-driven CTA button -->
      <div
        v-if="buttonText && linkOut"
        class="flex justify-end"
        :class="{ hidden: type === 'DSN' && hideDSN }"
      >
        <in-app-browser :href="linkOut" target="_blank">
          <div
            class="font-bold ml-auto text-[14px] leading-[20px] mt-2 hover:underline text-orange"
          >
            {{ buttonText }}
          </div>
        </in-app-browser>
      </div>
    </template>
  </div>
</template>

<script>
import CardLabel from '../common/CardLabel.vue';
import InAppBrowser from '../InAppBrowser.vue';
import { isGPCRPage } from '@/utils/conference-type';
import { mapGetters } from 'vuex';
export default {
  components: { CardLabel, InAppBrowser },
  props: {
    title: {
      type: String,
    },
    date: {
      type: String,
    },
    expTime: {
      type: String,
    },
    location: {
      type: String,
    },
    type: {
      type: String,
    },
    conferenceType: {
      type: String,
      default: 'Global',
    },
    note: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    linkOut: {
      type: String,
      default: '',
    },
    cardHtml: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('signup', ['DSN_MAP_FLAG']),
    cardStyle() {
      if (this.conferenceType === 'Global') return 'border-[1px] border-green border-solid';

      return 'bg-orange bg-opacity-5';
    },
    viewFloorplanButtonLink() {
      return isGPCRPage()
        ? this.$t('copy.experiencePage.allocationPanel.viewFloorplanButtonLink')
        : 'https://cdn.generationsmvmt.com/docs/Dream-and-Stories-Night-Floorplan.pdf';
    },
    hideDSN() {
      return isGPCRPage() && this.DSN_MAP_FLAG === 0;
    },
  },
};
</script>

<style></style>
